import { connect } from 'react-redux';
import _ from 'underscore';

var Spinner = require("components/utility/Spinner");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

function propsToSchoolID(props) {
	if (_.has(props.studentList, 'school'))
		return props.studentList.school.l2e_id
}

@connect(
	(state, props) => ({
		classStudentLists: RosterSelectors.studentLists({ state, filters: { school_id: propsToSchoolID(props) } }),
	}),
	(dispatch, props) => ({
		// removes students from student lists student in state
		deleteStudents: (stuID, slIDs) => {
			return new Promise((resolve, reject) => {
				dispatch(RosterActions.deleteStudents({ id: stuID, slIDs })).then(response => {
					resolve(response)
				})
			})
		},
		fetchStudent: (id) => {
			var embeds = ["student.password", "student.sso_data"].concat(RosterActions.GLOBAL_STUDENT_EMBEDS)
			return dispatch(RosterActions.fetchStudent({ id: id, embeds: embeds }))
		},
	})
)

class DeleteStudentModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("DeleteStudentModal");

		this.state = { loading: false }
	}

	// displays successful update message
	triggerSuccessMessage(stu, slCount) {
		var title = "Student Removed";
		if (slCount > 1) {
			var text = "You have removed " + stu.display_name + " from " + slCount + " classes.";
		} else {
			var text = "You have removed " + stu.display_name + " from " + slCount + " class.";
		}

		// show message
		window.wrNotifications.triggerDropDownNotification({
			title: title, text: text, icon: "ok-circle"
		}, 4000);

		// hide modal
		this.props.onHide();
	}

	// displays error on update message
	triggerErrorMessage() {
		window.wrNotifications.triggerDropDownNotification({
			title: "Oops!", text: "Something went wrong and the student was not removed",
			type: "error", icon: "remove"
		}, 4000);
	}

	// removes student from all associated student lists
	submit(slIDs) {
		var stu = this.props.student
		if (stu && slIDs) {

			// remove student from list
			// this removes student from state as well
			this.props.deleteStudents(stu.id, slIDs).then((response) => {
				if (response['destroyed']) {
					var slIDSize = Array.isArray(slIDs) ? _.size(slIDs) : 1
					this.triggerSuccessMessage(stu, slIDSize)

					// re-enter student into state with updates
					var activeSLIDs = stu.student_list_ids.active
					if (_.size(activeSLIDs) > 1 && _.size(slIDs) !== _.size(activeSLIDs)) {
						this.props.fetchStudent(stu.id)
					}
				} else {
					this.triggerErrorMessage()
				}
			})
		}
	}

	// renders start buttons or spinner
	renderButtons(activeSLCount) {
		if (this.state.loading) {
			return <Spinner scale={1} />
		} else {
			var stu = this.props.student
			var sl = this.props.studentList
			var activeSLIDs = stu.student_list_ids.active

			// store buttons in variable
			var cancelBtn = <button key="cancelBtn" className="btn" onClick={this.props.onHide}>Cancel</button>
			var removeAllBtn = <button key="removeAllBtn" className="btn buttonPrimary" onClick={this.submit.bind(this, activeSLIDs)}>Delete From All</button>
			var removeOneBtn = <button key="removeOneBtn" className="btn buttonPrimary" onClick={this.submit.bind(this, sl.id)}>Delete From 1 Class</button>

			// decide which buttons to show based on student's SL size
			if (activeSLCount > 1) {
				var buttons = [cancelBtn, removeAllBtn, removeOneBtn]
			}
			else {
				var buttons = [cancelBtn, removeOneBtn]
			}

			return (
				<div className="options">
					{buttons}
				</div>
			)
		}
	}

	// creates array of student lists
	renderMultipleSLs(slIDs) {

		// make array of list items with sl names
		var stuListItems = _.compact(_.map(slIDs, (slID) => {
			var sl = _.findWhere(this.props.classStudentLists, { id: slID })
			return <li key={slID} className="slName">{$wr.truncate(sl.name, 30)}</li>
		}))

		return (
			<ul>
				{stuListItems}
			</ul>
		)
	}

	// returns body  based on # of student lists
	renderDisplay() {
		var stu = this.props.student
		var slIDs = stu.student_list_ids

		// adjust content based on # of student lists
		if (slIDs && _.size(slIDs.active) === 1) {
			var modalContent = (
				<span>{stu.display_name} will be removed from <b>{this.props.studentList.name}</b></span>
			)
		} else {
			var modalContent = (
				<div>
					<div className="slCount">{stu.display_name} is included in {_.size(slIDs.active)} lists: </div>
					{this.renderMultipleSLs(slIDs.active)}
					<div className="slConfirm">Do you want to remove them from all lists or only <b>{this.props.studentList.name}</b>?</div>
				</div>
			)
		}

		return (
			<div>
				<div className='modalBody'>
					{modalContent}
				</div>
				{this.renderButtons(_.size(slIDs.active))}
			</div>
		)
	}

	render() {
		return (
			<div className="deleteStudentModalContainer">
				{this.renderDisplay()}
			</div>
		);
	}
};

module.exports = DeleteStudentModal;


// WEBPACK FOOTER //
// ./modules/components/org/roster/DeleteStudentModal.js